import { render, staticRenderFns } from "./Payok.vue?vue&type=template&id=a1d8b790&"
import script from "./Payok.vue?vue&type=script&lang=js&"
export * from "./Payok.vue?vue&type=script&lang=js&"
import style0 from "./Payok.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports